// 料率調整案件のラベル
export const LABELS = {
  TITLE_REGISTER: "料率調整案件情報登録",
  TITLE_UPDATE: "料率調整案件情報更新",

  TABLE_TITLE: "加盟店一覧",
  TABLE_ADJUSTMENT: "調整内容",
  ADD_MERCHANT: "加盟店追加",

  BRANCH: "No",
  CORP_NUMBER: "法人番号",
  CORP_NAME: "事業者名",
  CORP_KANA: "事業者名カナ",
  ADDRESS: "事業者住所",
  MERCHANT_NAME: "加盟店名",
  SERVICE_NAME: "サービス名",
} as const;
